module.exports = ["Alloy","Aluminum","Carbon Alloy","Carbon","Copper Brass","High Temp","Stainless","Titanium"]


//////////////////
// WEBPACK FOOTER
// ./src/config/material.json
// module id = 5698
// module chunks = 1